import LotteryNumlotDetailContainer from "../../components/lottery/containers/LotteryNumlotDetailContainer";
import LotteryNumlotDetailTemplate from "../../components/lottery/templates/LotteryNumlotDetailTemplate";
import LotteryLocalNav from "../../components/lottery/LotteryLocalNav";

function Numbers4() {
  return (
    <>
      <LotteryLocalNav placement="mainHeader" lotteryKey="nm4" />
      <section className="min-h-screen">
        <LotteryNumlotDetailContainer lotteryKey="nm4" Template={LotteryNumlotDetailTemplate} />
      </section>
      <LotteryLocalNav placement="mainFooter" lotteryKey="nm4" />
    </>
  );
}
export default Numbers4;
